import { type DocumentNode, gql } from '@apollo/client';

const allFieldMapsConfigQuery: DocumentNode = gql`
  query all_field_maps_configs {
    allFieldMapConfigs {
      totalCount
      edges {
        node {
          id
          name
          fieldmapSet {
            edges {
              node {
                id
                externalFieldId
                fieldDefinition {
                  id
                  name
                  slug
                  fieldType
                  isRequired
                  isEditable
                  isSystemField
                  isMultivalued
                  highlightIfBlank
                  choices
                  choiceList
                  uniqueValues
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default allFieldMapsConfigQuery;
